"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const moment_1 = __importDefault(require("moment"));
const date = {
    // given str in format YYYY-MM-DD, returns the MM or DD or YYYY as a number
    getFormatAsNum: (dateMoment, format) => Number(dateMoment.format(format)),
    // get object with each date component as number
    getMomentAsObject: (currDate) => ({
        day: date.getFormatAsNum(currDate, 'DD'),
        month: date.getFormatAsNum(currDate, 'MM'),
        year: date.getFormatAsNum(currDate, 'YYYY'),
    }),
    // get array of numbers from minYear to maxYear inclusive
    getYearsRange: (minDate, maxDate) => {
        const minYear = date.getFormatAsNum(minDate, 'YYYY');
        const maxYear = date.getFormatAsNum(maxDate, 'YYYY');
        const numYears = maxYear - minYear + 1;
        return Array.from(Array(numYears), (_, index) => index + minYear);
    },
    getMonthsRange: (viewingDate, min, max) => {
        const maxDate = date.getMomentAsObject(max);
        const minDate = date.getMomentAsObject(min);
        // if year is the min, get months from the month of the min date to 12
        if (viewingDate.year === minDate.year) {
            const endMonth = viewingDate.year === maxDate.year ? maxDate.month : 12;
            return Array.from(Array(endMonth - minDate.month + 1), (_, index) => index + minDate.month);
        }
        // if year is the max, get months from 1 to the month of the max date
        if (viewingDate.year === maxDate.year) {
            return Array.from(Array(maxDate.month), (_, index) => index + 1);
        }
        // if year is within range (exclusive), get all months 1 - 12
        return Array.from(Array(12), (_, index) => index + 1);
    },
    // input month index as 1 to 12
    getMonthName: (index, locale = 'en') => moment_1.default()
        .locale(locale)
        .month(index - 1)
        .format('MMMM'),
    // input index is value between 0 (Sunday) and 6 (Saturday)
    getDayName: (index, locale = 'en') => moment_1.default().locale(locale).day(index).format('dd'),
    // curr date is Object with day, month, and year and minDate and maxDate are moment instances
    withinRange: (currDate, minDate, maxDate) => {
        const currMoment = moment_1.default(`${currDate.year}-${currDate.month}-${currDate.day}`, 'YYYY-MM-DD');
        return currMoment.isBetween(minDate, maxDate, 'day', '[]');
    },
    // get next month
    addMonth: (currDate, max) => {
        const maxDate = date.getMomentAsObject(max);
        if (currDate.year === maxDate.year && currDate.month === maxDate.month) {
            return currDate;
        }
        return Object.assign(Object.assign({}, currDate), { month: currDate.month !== 12 ? currDate.month + 1 : 1, year: currDate.month !== 12 ? currDate.year : currDate.year + 1 });
    },
    // get previous month
    subMonth: (currDate, min) => {
        const minDate = date.getMomentAsObject(min);
        if (currDate.year === minDate.year && currDate.month === minDate.month) {
            return currDate;
        }
        return Object.assign(Object.assign({}, currDate), { month: currDate.month !== 1 ? currDate.month - 1 : 12, year: currDate.month !== 1 ? currDate.year : currDate.year - 1 });
    },
    // returns a 2D array with ints representing the days of the month
    getMonthArray: (currDate) => {
        let week = [];
        const month = [];
        let currDayNum = 1;
        const paddedMonth = `0${currDate.month}`.slice(-2);
        const monthLength = moment_1.default(`${currDate.year}-${paddedMonth}`).daysInMonth();
        // the day of week the 1st of the month lands on; range 0 (Sunday) to 6 (Saturday)
        let currDayOfWeek = moment_1.default(`${currDate.year}-${paddedMonth}`, 'YYYY-MM')
            .startOf('month')
            .day();
        // if month doesn't start on a Sunday (0), fill prior days with null
        let i = 0;
        while (i < currDayOfWeek) {
            week.push(null);
            i += 1;
        }
        // populate with days of the month
        while (currDayNum <= monthLength) {
            week.push(currDayNum);
            // week completed
            if (currDayOfWeek === 6) {
                month.push(week);
                week = [];
            }
            currDayNum += 1;
            currDayOfWeek = (currDayOfWeek + 1) % 7; // next day of week
        }
        // currDayOfWeek is now the day after the last day of the month
        // if not a Sunday (0), fill remaining days of the week with null
        if (currDayOfWeek !== 0) {
            while (currDayOfWeek <= 6) {
                week.push(null);
                currDayOfWeek += 1;
            }
            month.push(week);
        }
        return month;
    },
};
exports.default = date;
